import { combineReducers } from 'redux';

import appReducer from './slices/app';
import skillsReducer from './slices/skills';
import appointmentsReducer from './slices/appointments';
import engineersReducer from './slices/engineers';
import patchesReducer from './slices/patches';
import jobTypesReducer from './slices/jobTypes';
import skillCategoriesReducer from './slices/skillCategories';
import shiftPatternsReducer from './slices/shiftPatterns';
import teamsReducer from './slices/teams';
import timeBandsReducer from './slices/timeBands';
import adjustmentReducer from './slices/adjustments';
import scheduleReducer from './slices/schedule';
import dashboardReducer from './slices/dashboard';
import snackbarReducer from './slices/snackbar';
import userReducer from './slices/user';
import geographicAreaReducer from './slices/geographicAreas';
import jobsDetailsReducer from './slices/jobsDetails';
import abortReducer from './slices/abortCategories';
import regionsReducer from './slices/regions';
// Importing the `availabilityReducer` causes multiple test suites to fail due to a
// `TypeError: Cannot read properties of undefined (reading 'default')` error when trying to import stuff from slices
import availabilityReducer from './slices/availability';
import capacityTypesReducer from './slices/capacityTypes';
import reserveCapacityReducer from './slices/reserveCapacity';

const rootReducer = combineReducers({
  app: appReducer,
  skills: skillsReducer,
  appointments: appointmentsReducer,
  engineers: engineersReducer,
  patches: patchesReducer,
  jobTypes: jobTypesReducer,
  skillCategories: skillCategoriesReducer,
  shiftPatterns: shiftPatternsReducer,
  teams: teamsReducer,
  timeBands: timeBandsReducer,
  schedules: scheduleReducer,
  adjustments: adjustmentReducer,
  snackbar: snackbarReducer,
  user: userReducer,
  geographicAreas: geographicAreaReducer,
  regions: regionsReducer,
  dashboard: dashboardReducer,
  jobsDetails: jobsDetailsReducer,
  abortCategories: abortReducer,
  availability: availabilityReducer,
  capacityTypes: capacityTypesReducer,
  reserveCapacity: reserveCapacityReducer
});

export { rootReducer as default };
